import { defineMessages } from 'react-intl';
import { SportTermLookup, SportTerminology } from '../../lib/types';

export const scope = 'app.components.IceConflictWarning';

export default (termLookup: SportTermLookup) => {
  const fieldTerm = termLookup[SportTerminology.FIELD].toLowerCase();
  const sessionTerm = termLookup[SportTerminology.SESSION].toLowerCase();

  return defineMessages({
    tooltip: {
      id: `${scope}.tooltip`,
      defaultMessage: `Double-booked ${fieldTerm}: this ${sessionTerm} overlaps {slots} on the same ${fieldTerm}. Only one can run, so grouping will skip the later ${sessionTerm}.`
    },
    bannerTitle: {
      id: `${scope}.bannerTitle`,
      defaultMessage: `Double-booked ${fieldTerm}`
    },
    bannerBody: {
      id: `${scope}.bannerBody`,
      defaultMessage: `This ${sessionTerm} overlaps {other} on the same ${fieldTerm}: {slots}. Only one can run, so grouping will skip the later ${sessionTerm}.`
    },
    otherBooking: {
      id: `${scope}.otherBooking`,
      defaultMessage: 'another booking'
    },
    otherBookings: {
      id: `${scope}.otherBookings`,
      defaultMessage: '{count} other bookings'
    }
  });
};
